import { Pagination, Dialog, Button, Select, Option } from 'element-ui'
const element = {
  install: function(Vue) {
    Vue.use(Pagination)
    Vue.use(Dialog)
    Vue.use(Button)
    Vue.use(Select)
    Vue.use(Option)
  },
}

export default element
